import { mergeAttributes, Node, nodeInputRule } from "@tiptap/core";
import { VueNodeViewRenderer } from "@tiptap/vue-2";
import Component from "./InputField.vue";

export default Node.create({
  name: "input-field",
  group: "block",
  atom: true,
  addAttributes() {
    return {
      formulateSchema: null
    };
  },
  parseHTML() {
    return [
      {
        tag: "input-field"
      }
    ];
  },
  renderHTML({ HTMLAttributes }) {
    return ["input-field", mergeAttributes(HTMLAttributes)];
  },
  addInputRules() {
    return [nodeInputRule({ find: /\[\[/g, type: this.type })];
  },
  addNodeView() {
    return VueNodeViewRenderer(Component);
  }
});
